import { useEffect, useState } from 'react';
import { useMenu } from '../../../contexts/MenuContext';

export default function StickyDemo() {
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const { isMobileMenuOpen } = useMenu();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    const footer = document.getElementById('final-cta');
    if (footer) {
      observer.observe(footer);
    }

    return () => {
      if (footer) {
        observer.unobserve(footer);
      }
    };
  }, []);

  const scrollToDemo = () => {
    const demoSection = document.getElementById('demo-section');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Ocultar si el footer está visible O si el menú mobile está abierto
  if (isFooterVisible || isMobileMenuOpen) {
    return null;
  }

  return (
    <button
      onClick={scrollToDemo}
      className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50 px-4 sm:px-6 py-3 sm:py-4 bg-[#6D28D9] text-white rounded-full font-semibold shadow-2xl hover:bg-[#8B5CF6] transition-all duration-300 hover:scale-110 flex items-center gap-2 animate-pulse-slow cursor-pointer whitespace-nowrap text-sm sm:text-base"
    >
      <span className="hidden sm:inline">Probar Demo</span>
      <span className="sm:hidden">Demo</span>
      <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
        <i className="ri-rocket-line"></i>
      </div>
    </button>
  );
}
